import {useMutation} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import api, {TestServer} from 'src/services/api'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

export default function useTestConnection() {
  const {enqueueSnackbar} = useSnackbar()

  const mutation = useMutation({
    mutationFn: async (body: TestServer) => {
      const response = await api.server.testIntegration(body)
      enqueueSnackbar(response.data.message, {variant: response.data.statusCode === 200 ? 'success' : 'warning'})
    },
    onError: (error) => {
      handleErrorWithSnackbar(enqueueSnackbar, error, 'Não foi possível realizar a tentativa de conexão')
    },
  })
  return mutation
}
